import styled from '@emotion/styled';
import { breakpoints } from '@naf/theme';

export const Logo = styled.img`
  display: flex;
  align-items: center;
  transition: all 0.3s ease-in-out;

  @media (max-width: ${breakpoints.m}) {
    height: 40px;
    width: 40px;
  }
`;
